import api from "./api";

// 快速筛选课程标签
export const getQuickScreeningCourseTags = params => {
  return api('get', `/v1/management/quick-screening/course-tags`, params);
};

// 查询快速筛选列表
export const getQuickScreeningList = params => {
  return api('get', `/v1/management/quick-screening/list`);
};


// 保存课程快速筛选
export const getQuickScreeningSaveCourse = params => {
  return api('post', `/v1/management/quick-screening/save-course`, params);
};

// 保存活动快速筛选标签
export const getQuickScreeningSaveActivity = params => {
  return api('post', `/v1/management/quick-screening/save-activity`, params);
};